'use strict';

function introRouting($stateProvider) {

    let introBaseState = 'root.owner';

    $stateProvider

    /**
     * WITHOUT END-POINT Section - Personal info
     */
        .state('' + introBaseState + '', {
            abstract: true,
            url: "/owner",
            views: {
                '': {
                    template: "<ui-view/>",
                    controller: "OwnerSectionController"
                },
                'sidebar@root': {
                    template: require("./navigation.html")
                }
            },
            resolve: {
                loadSectionSpecific: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('./owner.section-specific.js');
                            $ocLazyLoad.load({name: module.name});
                            resolve(module);
                        })
                    });
                },
                loadClerkLedgerDeliverableCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-deliverable/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-deliverable")
                    });
                },
            },
            data: {
                baseState: introBaseState,
                sectionName: 'Personal info',
                requiresLogin: true,
                pageTitle: 'Personal info',
                showSideMenu: true
            }
        })

        .state('' + introBaseState + '.overview', {
            url: "/overview",
            template: require("./overview.html"),
            data: {pageTitle: 'Personal Info'}
        })

        .state('' + introBaseState + '.preferences', {
            url: "/preferences",
            template: require("./preferences.html"),
            data: {pageTitle: 'Preferences'}
        })

        .state('' + introBaseState + '.what-to-get-done', {
            url: "/what-to-get-done",
            template: require("./what-to-get-done.html"),
            data: {pageTitle: '1. Decide how to use the tool - What to get done'}
        })

        .state('' + introBaseState + '.survey', {
            url: "/survey",
            template: require("./survey.html"),
            data: {pageTitle: '1. Decide how to use the tool - Survey'}
        })

        .state('' + introBaseState + '.overview.request-invite', {
            url: "/request-invite",
            onEnter: /*@ngInject*/ function ($state) {
                Intercom('onHide', _.once(function () {
                    $state.go('' + introBaseState + '.overview');
                }));
                Intercom('showNewMessage', 'Hi! I would like to get Beta access to ' + env.SITENAME);
            },
            onExit: /*@ngInject*/ function () {
                Intercom('hide');
            },
            data: {pageTitle: 'request-invite'}
        });

};

function routing($stateProvider) {

    let baseState = 'root.api-endpoints.existing.owner';

    $stateProvider

    /**
     * Section - Personal info
     */
        .state('' + baseState + '', {
            abstract: true,
            url: "/owner",
            views: {
                '': {
                    template: "<ui-view/>",
                    controller: "OwnerSectionController"
                },
                'sidebar@root': {
                    template: require("./navigation.html")
                }
            },
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkSupportingDocument_columns_by_step = 'supporting-documents.relevance';
                    routeBasedVisibilitySettings.ClerkAccount_columns_by_step = 'simple';
                    routeBasedVisibilitySettings.ClerkFiscalYear_columns_by_step = 'edit-fiscal-year';
                    routeBasedVisibilitySettings.ClerkLedger_columns_by_step = 'attributes';
                    routeBasedVisibilitySettings.ClerkInvoice_columns_by_step = 'attributes';
                    routeBasedVisibilitySettings.ClerkInvoiceRow_columns_by_step = 'default';
                    routeBasedVisibilitySettings.ClerkInvoiceItem_columns_by_step = 'attributes';
                    routeBasedVisibilitySettings.ClerkTravelClaim_columns_by_step = 'attributes';
                },
                loadSectionSpecific: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('./owner.section-specific.js');
                            $ocLazyLoad.load({name: module.name});
                            resolve(module);
                        })
                    });
                },
                loadLocationCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/location/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-location")
                    });
                },
                loadInboxQueryCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/inbox-query/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-inbox-query")
                    });
                },
                loadInboxQueryResponseCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/inbox-query-response/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-inbox-query-response")
                    });
                },
                loadWhereaboutCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/whereabout/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-whereabout")
                    });
                },
                loadIndicatedEntityWhereaboutPresenceCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/indicated-entity-whereabout-presence/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-indicated-entity-whereabout-presence")
                    });
                },
                loadImportSessionCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/import-session/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-import-session")
                    });
                },
                loadClerkAmbitionLevelCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ambition-level/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ambition-level")
                    });
                },
                loadClerkCurrencyCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-currency/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-currency")
                    });
                },
                loadClerkAccountCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-account/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-account")
                    });
                },
                loadClerkAccountCategoryCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-account-category/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-account-category")
                    });
                },
                loadClerkTaxEntityTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-entity-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-entity-type")
                    });
                },
                loadClerkFiscalYearCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-fiscal-year/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-fiscal-year")
                    });
                },
                loadClerkAccountBalanceCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-account-balance/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-account-balance")
                    });
                },
                loadClerkTaxEntityCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-entity/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-entity")
                    });
                },
                loadClerkTaxRegionCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-region/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-region")
                    });
                },
                loadClerkLedgerDeliverableCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-deliverable/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-deliverable")
                    });
                },
                loadClerkTaxEntityRelationCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-entity-relation/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-entity-relation")
                    });
                },
                loadClerkTaxEntityRelationTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-entity-relation-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-entity-relation-type")
                    });
                },
            },
            data: {
                baseState: baseState,
                sectionName: 'Personal info',
                importSessionProductScope: 'clerk',
                pageTitle: 'Personal info',
                showSideMenu: true
            }
        })

        .state('' + baseState + '.overview', {
            url: "/overview",
            template: require("./overview.html"),
            data: {
                pageTitle: 'Personal Info',
                showSideMenu: true
            }
        })

        .state('' + baseState + '.my-tax-entities', {
            url: "/my-tax-entities",
            template: require("./my-tax-entities.html"),
            data: {pageTitle: 'Personal Info'}
        })

        .state('' + baseState + '.preferences', {
            url: "/preferences",
            template: require("./preferences.html"),
            data: {pageTitle: 'Personal preferences'}
        })

        .state('' + baseState + '.what-to-get-done', {
            url: "/what-to-get-done",
            template: require("./what-to-get-done.html"),
            data: {pageTitle: '1. Decide how to use the tool - What to get done'}
        })

        .state('' + baseState + '.survey', {
            url: "/survey",
            template: require("./survey.html"),
            data: {pageTitle: '1. Decide how to use the tool - Survey'}
        })


}

export default angular
    .module('owner.routing', [])
    .config(function ($stateProvider) {

        // Lazy load the states instead of loading them all at app bootstrap

        /*
        let lazyIntroStateProvider = {
            states: [],
            state: function (name, stateConfig) {
                let state = angular.merge({name: name}, stateConfig);
                this.states.push(state);
                return this;
            }
        };
        introRouting(lazyIntroStateProvider);
        $stateProvider.state('root.owner.**', {
            url: "/owner",
            lazyLoad: function ($transition$, ParentService) {
                return lazyIntroStateProvider;
            },
        });
        */
        // Eager-loading intro-states since there are issues with those routes and since they are so few, it is ok to load them eagerly for now
        introRouting($stateProvider);

        /*
        let lazyStateProvider = {
            states: [],
            state: function (name, stateConfig) {
                let state = angular.merge({name: name}, stateConfig);
                this.states.push(state);
                return this;
            }
        };
        routing(lazyStateProvider);
        $stateProvider.state('root.api-endpoints.existing.owner.**', {
            url: "/owner",
            lazyLoad: function ($transition$, ParentService) {
                return lazyStateProvider;
            },
        });
        */

        // Eager-loading states at this level so that initial browsing experience for the most common routes are quick
        routing($stateProvider);

    });



// WEBPACK FOOTER //
// .-dna/app/sections/1-owner/owner.routing.js